<template>
	<div v-editable="blok">
		<NuxtLink
			v-if="blok.link_url.linktype == 'story'"
			:to="'/' + blok.link_url.story.full_slug"
			class="transition-colors duration-300 ease-linear hover:text-blue-dark"
		>
			{{ blok.link_name }}
		</NuxtLink>
		<NuxtLink
			v-else
			:to="blok.link_url.cached_url"
			class="transition-colors duration-300 ease-linear hover:text-blue-dark"
		>
			{{ blok.link_name }}
		</NuxtLink>
	</div>
</template>

<script setup lang="ts">
import type { BlokSimpleLink } from "~/types/storyblok/storyblok";

interface Props {
	blok: BlokSimpleLink;
}
const { blok } = defineProps<Props>();
</script>
